import { mapActions } from 'vuex'

// Shared by App.vue's drawer and AnonymousNotice.vue: both offer signing in as an explicit
// action rather than an automatic redirect.
export default {
  methods: {
    ...mapActions('oidcStore', [
      'authenticateOidc',
    ]),

    signIn: function() {
      // Come back to the page the user was on rather than the home page.
      this.authenticateOidc({ redirectPath: this.$route.fullPath })
    },
  },
};
